import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

interface IDashPagination {
  currentPage: number;
  totalPages: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const DashboardTablePagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
}: IDashPagination) => {
  let visiblePages = 3;

  // setting visible pages if total pages are more than or less than 3 here
  if (totalPages > 3 && totalPages < 5) {
    visiblePages = 4;
  } else if (totalPages >= 5) {
    visiblePages = 5;
  }

  // function to render page numbers declared here
  const renderPageNumbers = () => {
    const pages = [];

    let startPage = Math.max(currentPage - Math.floor(visiblePages / 2), 1);

    let endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - visiblePages + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <span key={i} className='inline-block'>
          <button
            onClick={() => setCurrentPage(i)}
            className={`select-none flex justify-center font-semibold items-center size-8 hover:opacity-60 duration-300 ${
              i === +currentPage
                ? 'bg-legal-brown text-legal-dark-blue'
                : 'text-legal-brown border-2 border-legal-brown'
            } rounded-lg mx-1 focus:outline-none`}
          >
            {i}
          </button>
        </span>
      );
    }

    return pages;
  };

  // rendering dashboard table pagination component here
  return (
    <div className='flex items-center'>
      <div className='flex items-center'>
        {currentPage > 1 ? (
          <button
            onClick={() => setCurrentPage((state) => state - 1)}
            className='text-legal-brown hover:opacity-70 duration-300'
          >
            <FiChevronLeft className='h-6 w-6' />
          </button>
        ) : (
          <span className='text-legal-brown cursor-not-allowed opacity-60'>
            <FiChevronLeft className='h-6 w-6' />
          </span>
        )}

        {renderPageNumbers()}

        {currentPage < totalPages - 2 && totalPages > 5 ? (
          <>
            {totalPages > 5 && currentPage < totalPages - 3 && (
              <p className='h-8 w-8 text-center'>...</p>
            )}

            <span>
              <button
                onClick={() => setCurrentPage(totalPages)}
                className={`select-none flex justify-center font-semibold items-center size-8 hover:opacity-70 duration-300 ${
                  totalPages === +currentPage
                    ? 'bg-legal-brown text-legal-dark-blue'
                    : 'text-legal-brown border-2 border-legal-brown'
                } rounded-lg mx-1 focus:outline-none`}
              >
                {totalPages}
              </button>
            </span>
          </>
        ) : null}

        {currentPage < totalPages ? (
          <button
            onClick={() => setCurrentPage((state) => state + 1)}
            className='text-legal-brown hover:opacity-70 duration-300'
          >
            <FiChevronRight className='h-6 w-6' />
          </button>
        ) : (
          <span className='text-legal-brown cursor-not-allowed opacity-60'>
            <FiChevronRight className='h-6 w-6' />
          </span>
        )}
      </div>
    </div>
  );
};

export default DashboardTablePagination;
